/**
 * 拖出该按钮，动态创建一个通栏
 */
import { primaryStagePageLayoutGenerator as primaryStagePageLayoutGenerator } from "store/modules/stage/state"
import { control_popover_button_children } from "materials/button/menus/index"
import { simpleDeepClone, smartMathMax } from "utils"

class Popover {
  constructor(vue) {
    this.context = vue
    this.request_prefix = this.context.request_prefix
  }
  init() {
    let vdrPath = this.context.$el
      .closest(".vdr")
      .classList.values()
      .find(item => item.indexOf("container_id") > -1)
    // 先判断当前页面是否已经存在该button对应的弹出框
    const popover = this.context.$store.state[this.request_prefix].page.pageLayoutList.find(
      pageLayout => pageLayout.options.source_id === vdrPath
    )
    if (this.context.options.popoverPath && popover) {
      return
    }
    // 还没有创建过弹出框，需要初始化
    if (!popover) {
      // 需要添加一个按钮组件，控制弹出框的显示
      const allRects = this.context.getAttrById.call(this.context, this.context.$store.state[this.request_prefix], {
        container_id: 0
      }).children
      let _rect_id = -1
      if (allRects.length > 0) {
        _rect_id = smartMathMax(
          ...allRects.map(function (o) {
            return o.rect_id
          })
        )
      }
      let rect_id = _rect_id + 1
      const rectAttr = simpleDeepClone(control_popover_button_children[0].attribute)
      rectAttr.options.popoverSourceId = vdrPath
      rectAttr.options.zIndex = 100000
      rectAttr.options.isShow = false
      const params = {
        containerID: 0,
        data: rectAttr
      }
      this.context.$store.dispatch(this.request_prefix + "/addElement", params)

      // 不存在则创建
      let popoverParams = [new primaryStagePageLayoutGenerator(1)][0]
      // 找到当前通栏中的最大id
      const id =
        Math.max.apply(
          0,
          this.context.$store.state[this.request_prefix].page.pageLayoutList.map(pageLayout => pageLayout.id)
        ) + 1
      popoverParams.id = id
      // 设置弹出框的样式
      popoverParams.options.padding = [0, 0, 0, 0]
      popoverParams.layout.rows[0].options.height = 200
      popoverParams.options.source_id = vdrPath
      popoverParams.options.sourceIds = simpleDeepClone(this.context.myid)
      popoverParams.options.inDocument = "popover"
      popoverParams.options.bg = [
        {
          color: "rgba(255, 255, 255, 0)",
          isThemeColor: false,
          label: "颜色",
          type: "color"
        }
      ]
      // 弹出框默认属性
      popoverParams.options.popoverParams = {
        popoverPositonType: "top",
        width: 200,
        height: 200,
        spacing: 0,
        spacingH: 0,
        opacity: 100,
        borderTypeFlag: 1,
        borderRadius: [0, 0, 0, 0],
        borderWidth: [0, 0, 0, 0],
        borderStyle: "solid",
        borderColor: "rgb(61, 130, 242)",
        borderIsThemeColor: false,
        triggerType: "hover",
        showCloce: false
      }
      let layout = popoverParams.layout.rows[0].options
      layout = {
        ...layout,
        showBorder: false,
        borderTypeFlag: 1,
        borderRadius: [0, 0, 0, 0],
        borderWidth: 1,
        borderColor: "rgba(0, 0, 0, 1)",
        paddingTypeFlag: 1,
        padding: [0, 0, 0, 0],
        opacity: 100,
        boxShadowColor: ["rgba(255, 255, 255, 1)"],
        boxShadowH: [0],
        boxShadowV: [0],
        boxShadowBlur: [0],
        boxShadowSpread: [0],
        bg: [
          {
            color: "rgba(255, 255, 255, 1)",
            isThemeColor: false,
            label: "颜色",
            type: "color"
          }
        ]
      }
      popoverParams.layout.rows[0].options = layout
      popoverParams.layout.rows[0].rectIds.push(rect_id)
      const index = this.context.$store.state[this.request_prefix].page.pageLayoutList.length - 1
      this.context.$changeOptionsEV(vdrPath, "popoverPath", false, null, this.context.myid, true)
      this.context.$store.dispatch(this.request_prefix + "/insertPageLayout", {
        pagelayout_data: popoverParams,
        index: index
      })
    } else {
      // 弹出框已经存在了，历史数据，直接绑定关系
      this.context.$changeOptionsEV(vdrPath, "popoverPath", false, null, this.context.myid, true)
    }
  }
}

export default {
  methods: {
    popoverPlugin() {
      const popover = new Popover(this)
      popover.init()
    }
  }
}
